import {inject, injectable} from 'inversify';

import type {ProgramExpandCommonFields} from '../../../../api/program';
import type {Expand} from '../../../../api/types';

import {programExpandCommon} from '../../../../api/program';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class ProgramExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = programExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace ProgramExpandJrpc {
  export type ExpandedFields = ProgramExpandCommonFields;
}
